import React, {useState, useEffect} from 'react';
import clsx from 'clsx'
import { Grid, Button } from '@material-ui/core';
import NavLogo from '../../assets/images/nav_logo.png'
import Background from '../../assets/images/background.png'
import {useConfigContext} from '../../_context/config.context'
import useStyles from './styles'
import formatter from "../../_helpers/formatter";

export default function SideBar({handleEndChatBtn, sendMessage, webSocket, sessionEndedByUser}) {
  const {config} = useConfigContext()
  const {NAVIGATION_ITEMS, SIDEBAR, ENABLE_FEEDBACK} = config
  const {url} = SIDEBAR.logo
  const classes = useStyles({ ...config })

  const triggerPostBack = item => {
    sendMessage({
      title: item.label,
      payload: item.payload,
      text: item.label
    })
  }

  const handleLogoClick = () => {
    if(url) window.open(url, '_blank')
  }

  const useTypeWriter = (content = '') => {
    const [prevContent, setPrevContent] = useState(content);
    const [animatedContent, setAnimatedContent] = useState('');
    const hasContentChanged = prevContent === content;

    const generateContent = () => {
        setAnimatedContent((prevAnimatedContent) => {
            const charCount = prevAnimatedContent.length;
            if (prevAnimatedContent.length + 1 !== content.length) setTimeout(generateContent, 1);

            return prevAnimatedContent + content[charCount];
        });
    };

    useEffect(() => {
        if (!hasContentChanged) return;

        setPrevContent(content);
        generateContent(content);
    }, [hasContentChanged]);

    return animatedContent;
  };

  return (
    <Grid item md={3} className={classes.sideBarContainer} container>
      <Grid item container className={classes.navItemsContainer} data-testid='sidebar-container'>
        <div className='item logo'>
          <img
            src={NavLogo}
            alt='logo'
            className={clsx(classes.navLogo, url && 'href')}
            onClick={handleLogoClick}
          />
        </div>
        <h1 style={{ fontSize: '24px', fontWeight: 'bold', textAlign: 'center', margin: '20px 0', color: 'white' }}>
          MSIG HR Chatbot
        </h1>
        <div className={classes.navDescription}>
        {useTypeWriter('Need quick answers about leave entitlements, benefits, or company policies? This AI-powered MSIG HR chatbot is your all-in-one platform, designed to provide seamless support whenever you need it. No more sifting through lengthy documents or waiting for HR responses—simply ask and receive instant, precise information.\n\nFrom payroll inquiries and medical claims to workplace policies and holiday schedules, the MSIG HR chatbot ensures you have access to essential HR information Available 24/7, it offers a convenient and reliable way to stay informed, empowering you to focus on what truly matters.')}
        </div>
        <img
          src={Background}
          className={classes.background}
        />
        <div className={classes.navDescriptionFooter}>
          <div>Brought to you by <a href='https://www.pand.ai' target='_blank' rel="noopener noreferrer">Pand.ai Pte. Ltd.</a></div>
          <div>Southeast Asia’s leading Chatbot developer</div>
        </div>
        {/* <img
            src={require("../../assets/images/nav_logo_bottom.png")}
            alt='logo'
            className={clsx(classes.navLogoBottom, url && 'href')}
            onClick={handleLogoClick}
          /> */}
      </Grid>
      {
        SIDEBAR.enableEndChatButton
        &&
        <Button className={classes.endButton} onClick={() => handleEndChatBtn(ENABLE_FEEDBACK)} disabled={!webSocket} data-testid='sidebar-endchat-button'>
          Logout
          <i className="fas fa-sign-out-alt"></i>
        </Button>
      }
    </Grid>
  );
}
